import { useEffect, useState } from "react";
import infoIcon from "../../../../src/asset/images/yellow-info.svg";
import { Off_Market } from "../../../Configuration/API_URL";
import { AESEncryption, ApiResDecrypt, formatDate, noDataFound } from "../../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import Loader from "../../../Components/Common/Loader";
import attachIcon from "../../../asset/images/orange-attachment.svg";
import axiosInstance from "../../../CommonMethhods/axiosInstance";


function Drafts(props) {
  const { setSelectedDraft } = props;
  const storeToken = localStorage.getItem("ssoToken");
  const [draftData, setDraftData] = useState([]);
  const [count, setCount] = useState("");
  const [loader, setLoader] = useState(false)

  useEffect(() => {
    getDraftData();
  }, []);

  const getDraftData = async () => {
    setLoader(true);

    const payload = {
      pageNo: -1,
      pageSize: -1,
      flag: "DRAFT"
    }

    const encPayload = AESEncryption(payload);

    try {
      const getDetails = await axiosInstance.post(
        Off_Market.draftData,
        `"${encPayload}"`,

      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        setDraftData(res?.data?.tradeDetails);
        setCount(res?.data?.totalClientCnt)
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);

    } finally {
      setLoader(false);
    }
  };

  const handleViewDetails = (sr) => {
    setSelectedDraft({
    ...sr,
    rows: sr?.trades || [],
  });
  };


  return (

    <div className="off-market-main">
      <div className="ckr-page">
        {draftData?.length > 0 &&
        <div className="info-banner info-flex">
          <div className="wrap-infoicon">
          <img src={infoIcon} alt="email icon" className="info-icon" />
          </div>
          {count} draft{count > 1 ? "'s" : ""} requests are pending
          <span className="banner-text">
            supporting document upload. Upload documents to submit these to the Checker.
          </span>
        </div>
      }

        <div className="ckr-section">
          <div className="draft-header">
            <span className="ckr-section-title">Your Service Request Drafts</span>
          </div>
           {loader ?
          <div className="loader-alignment">
            <Loader />
          </div>
          :
          
          draftData && draftData?.length > 0 ?
          <div className="ckr-table-wrapper">
            
            <table className="ckr-table draft-maker new-draft">
              <thead>
                <tr>
                  <th>Client Name</th>
                  <th>Client Code</th>
                  {/* <th>Sr ID</th>
                  <th>ISIN</th>
                  <th>No. of Transactions</th>
                  <th>Submission Date</th> */}
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {draftData.map((sr, index) =>
                  // sr?.trades?.map((trade, index) => (
                    <tr
                      key={index}
                    // className={selectedSR?.id === sr.id ? "ckr-active-row" : ""}
                    >
                      <td>{sr?.clientName || "-"}</td>
                      <td>{sr?.clientCode || "-"}</td>
                      {/* <td>{sr?.serviceRequestId || "-"}</td>
                      <td>{sr?.isin || "-"}</td>
                      <td>{sr?.totalRecords || "-"}</td>
                      <td>{formatDate(sr?.submittedOn) || "-"}</td> */}
                      <td>
                        <span
                        className={`status-draft ${sr?.status || ""}`}
                        >
                          {sr?.status === "" &&
                            <>Doc Pending</>
                          }
                        </span>
                      </td>
                      <td>
                        <div className="view-btn">
                        <button className="view-doc-btn draft-doc" onClick={() => handleViewDetails(sr)}>
                          <img src={attachIcon} alt="attachment" /> 
                          Upload Document
                        </button>
                      </div>
                      </td>
                    </tr>
                  // ))
                  )}
              </tbody>
            </table>
          </div>
          
          :
           
          <div className="step-content report-error-message">
            {noDataFound()}
          </div>
          }
        </div>
      </div>
    </div>
  );
}

export default Drafts;
